export const accountGOSFilterFields = {
  REGISTER_CODE: 'registerCode',
  EXPIRATION_DATE: 'expirationDate',
};

export const FORM_ACCOUNT_GOS_FILTER = 'FORM_ACCOUNT_GOS_FILTER';
